var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCloudSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.702 9.05c-.26-1.16-.71-2.16-1.37-2.99-.02-.03-.04-.06-.06-.08-2.2-2.66-5.8-2.65-8.23-1.27-2.08 1.19-3.85 3.7-2.92 7.28-2.13.52-3.11 2.38-3.11 4.06 0 1.88 1.23 3.99 3.97 4.19H16.362c1.42 0 2.78-.53 3.83-1.49 2.51-2.22 2.18-5.84.42-7.92a5.238 5.238 0 0 0-2.91-1.78zM21.62 9.732a6.62 6.62 0 0 0-2.69-1.87c-.32-1-.78-1.89-1.38-2.67-.03-.04-.06-.08-.1-.13.19-.04.39-.05.58-.05a3.73 3.73 0 0 1 3.73 3.73c0 .34-.04.67-.14.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCloudSunny);
export default __webpack_public_path__ + "static/media/vuesax-bold-cloud-sunny.0a68cebc2e95b6e20703ae7a324ddd58.svg";
export { ForwardRef as ReactComponent };